import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, Slide } from "react-toastify";
import styled from "styled-components";
import colors from "styles/colors";
import HeaderMobile from "../../components/HeaderMobile";
import Sidebar from "../../components/Sidebar";
import { useHistory } from "react-router-dom";
import Header from "../../components/Header";
import mainAction from "../../modules/main/actions";
import pageTitleList from "../../modules/utils/pageTitleList";
import { useTranslation } from "react-i18next";
import TopBarMobile from "../../components/TopBarMobile";

const Mobile = ({ children, extraPage }) => {
  const dispatch = useDispatch();
  const [isMenuVisible, setMenuVisible] = useState(false);
  const history = useHistory();
  const isWizard = history.location.pathname === "/wizard";
  const [t] = useTranslation();
  const titleAndSubTitle = pageTitleList.getPageTitleList(t);
  const titleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].title
    : "";
  const subTitleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].subTitle || ""
    : "";

  const handleMenuClicked = (dashboard = "google") => {
    if (dashboard === "google" || dashboard === "facebook" || dashboard === "settings") {
      dispatch(mainAction.currentDashboard(dashboard));
    }

    setMenuVisible(false);
  };

  return (
    <StyledContainer extraPage={extraPage} isWizard={isWizard}>
      {isWizard ? (
        <>
          <Header />
          {children}
        </>
      ) : (
        <>
          <HeaderMobile onMenuClicked={() => setMenuVisible(true)} extraPage={extraPage}></HeaderMobile>
          {!extraPage && <TopBarMobile title={titleName} subTitle={subTitleName} />}
          {children}
          <Sidebar isVisible={isMenuVisible} onBackdropClicked={(dashboard) => handleMenuClicked(dashboard)}></Sidebar>
        </>
      )}
      {
        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover
          transition={Slide}
        />
      }
    </StyledContainer>
  );
};

export default Mobile;

const StyledContainer = styled.div.attrs((props) => ({
  padding: props.isWizard ? "" : props.extraPage ? "70px 0 0;" : "70px 0 0",
}))`
  background-color: ${colors.background};
  height: 100vh; /* Use vh as a fallback for browsers that do not support Custom Properties */
  height: 100dvh;
  width: 100vw;
  overflow: hidden auto;
  box-sizing: border-box;
  padding: ${(props) => props.padding};

  @media screen and (max-width: 834px) {
    > div {
      margin: 5px 8px 0 8px;
    }
  }
`;
